import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { EyeSlashIcon } from '@heroicons/react/24/outline'

// A private reservation stays in the app but is left out of the calendar.ics feed.
export const PrivateBadge: FC = () => {
  const { t } = useTranslation()
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full bg-primary-50 px-2 py-0.5 text-xs font-semibold text-primary-700"
      title={t('reservationForm.privateHelp')}
      data-testid="private-badge"
    >
      <EyeSlashIcon className="h-3 w-3" aria-hidden="true" />
      {t('reservations.private')}
    </span>
  )
}
